/**
 * 龙门特殊域名下载页（LMBG 落地页）
 */
export const LM_DOWNLOAD_HOSTS = ["web.dgasbdy.xyz"];

/** 龙门落地页友盟 / cnzz */
export const LM_CNZZ_SRC = "https://s9.cnzz.com/z.js?id=1281497885&async=1";

export function getCurrentHost() {
  if (typeof window === "undefined") return "";
  return window.location.hostname.toLowerCase();
}

export function isLmDownloadHost(host = getCurrentHost()) {
  if (!host) return false;
  return LM_DOWNLOAD_HOSTS.includes(host);
}

export function injectCnzz(src) {
  if (typeof document === "undefined" || !src) return;
  if (document.querySelector(`script[data-cnzz-src="${src}"]`)) return;
  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  script.setAttribute("data-cnzz-src", src);
  document.body.appendChild(script);
}
